<template>
  <form id="form">
    <v-text-field
      dense
      v-for="field in fields"
      :key="field.index"
      class="mb-4"
      :id="field.index"
      :name="field.index"
      :autocomplete="field.autocomplete"
      v-model="$v.authData[field.index].$model"
      :outlined="fields_settigs.outlined"
      :label="field.label"
      :type="
        field.type === 'password'
          ? showPassword
            ? 'text'
            : 'password'
          : field.type
      "
      :hide-details="fields_settigs['hide-details']"
      :single-line="fields_settigs['single-line']"
      :append-icon="
        field.type === 'password'
          ? showPassword
            ? 'mdi-eye'
            : 'mdi-eye-off'
          : ''
      "
      @mousedown="showPassword = !showPassword"
      @mouseup="showPassword = !showPassword"
      @keyup.enter="enterOnField()"
    />
    <div class="text-left my-4" style="align-self: flex-start">
      <a class="caption" :href="recovery.link">{{ recovery.text }}</a>
    </div>
    <c-button
      mode="toolbar"
      :color="button.color"
      :loading="loader"
      :disabled="disabledBtn"
      @click="signIn"
    >
      {{ button.text }}
    </c-button>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import snackFunction from "../../mixins/snackFunction";
import cButton from "../@custom/cButton";
import { HTTP } from "../../http";

export default {
  name: "AuthForm",
  components: {
    cButton,
  },
  mixins: [snackFunction],
  validations: {
    authData: {
      username: { required },
      pass: {},
    },
  },
  props: {
    redirectPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fields: [
        {
          type: "username",
          index: "username",
          label: "Логин",
          icon: "fa-user",
          autocomplete: "username",
        },
        {
          type: "password",
          index: "pass",
          label: "Пароль",
          icon: "fa-unlock-alt",
          autocomplete: "off",
        },
      ],
      fields_settigs: {
        outlined: true,
        "hide-details": true,
        "single-line": false,
      },
      button: {
        color: "success",
        text: "Войти",
      },
      authData: {
        username: "",
        pass: "",
      },
      showPassword: false,
      loader: false,
      base_url: process.env.VUE_APP_OLD_BACK,
      recovery: {
        text: "Забыли пароль?",
        link: `${process.env.VUE_APP_OLD_BACK}recovery_password/`,
      },
    };
  },
  mounted() {
    let params = this.$route.path.split("&");
    params.forEach((param) => {
      let item = param.split("=");
      if (item.length === 2) {
        if (item[0] === "login" || item[0] === "/login") {
          this.authData.username = item[1];
        }
      }
    });

    // if (this.$route.params) {
    //   this.authData.username = ''
    // }
  },
  computed: {
    disabledBtn() {
      return this.authData.username.length < 2;
    },
  },
  methods: {
    enterOnField() {
      this.signIn();
    },
    async redirect(bearer) {
      const res = await this.$store.dispatch("common/getRedirectDetails");
      const details = await this.$store.dispatch("common/getUserDetails");
      if (res.data !== "https://02") {
        await this.$store.dispatch("common/getTokenForOldBack");
        localStorage.removeItem("so_token");
        location.assign(
          `${this.base_url}?token=${this.token}&soToken=${bearer}`
        );
      } else {
        const path = this.getStartPage(details);
        location.replace(`${location.origin}/${path}`);
      }
    },
    async signIn() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loader = true;
        const loginRes = await this.$store.dispatch("login", this.authData);
        if (loginRes.status === 200) {
          HTTP.defaults.headers.common[
            "Authorization"
          ] = `${loginRes.data.token_type} ${loginRes.data.access_token}`;
          await this.redirect(loginRes.data.access_token);
        } else {
          switch (loginRes.status) {
            case 401: this.handleStatus401(); break;
            case 403: this.handleStatus403(loginRes); break;
            case 422: this.handleStatus422(loginRes); break;
            case 500: this.handleStatus500(loginRes); break;
            default: this.handleStatus401(); break;
          }
        }
        this.loader = false;
      } else {
        this.handleValidationFail();
      }
    },
    handleValidationFail() {
      this.$emit("loginDisabled", true);
      this.showSnack(
        'Поле "Логин" обязательно для заполнения',
        "warning",
        6000
      );
    },
    handleStatus401() {
      this.showSnack("Логин или пароль неверные", "warning");
    },
    handleStatus403() {
      this.showSnack("Доступ запрещен", "warning");
    },
    handleStatus422(res) {
      const errors = [];
      for (const key in res.data.errors) {
        if (Object.hasOwnProperty.call(res.data.errors, key)) {
          if (key === "pass") {
            errors.push('Поле "Пароль" обязательно для заполнения');
          } else {
            errors.push(res.data.errors[key]);
          }
        }
      }
      errors.join(",");
      this.showSnack(errors.join(", "), "warning");
    },
    handleStatus500(res) {
      if (Object.prototype.hasOwnProperty.call(res.data, "error")) {
        this.showSnack(res.data.error, "error");
      } else {
        this.showSnack("Необработанная ошибка авторизации", "error");
      }
    },
    getStartPage(details) {
      let start = "main";
      if (details.user.customer_id) start = "customer_cabinet";
      const page = details.group.group_site;
      if (page.trim() !== '') start = page.trim();
      return start + "#/?fromLogin";
    }
  },
  watch: {
    redirectPath(value) {
      if (typeof value === "string") {
        this.redirect(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px 24px;
  margin-top: 24px;
}
.v-input,
.v-sheet {
  width: 100%;
}
</style>
